// Adds "Add to wishlist" and "Compare" links into Craft's native Quick Add modal once its
// content loads, using localStorage so it works without a wishlist app installed.
(function () {
  function getList(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }
  function setList(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }
  function toggleItem(key, handle, btn, onLabel, offLabel) {
    var list = getList(key);
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
      btn.textContent = onLabel;
    } else {
      list.push(handle);
      btn.textContent = offLabel;
    }
    setList(key, list);
  }

  function enhanceModal(container) {
    if (container.querySelector('.quickview-extra-links')) return;
    var productUrl = container.closest('[data-product-url]');
    var link = container.querySelector('a[href]');
    var handle = link ? link.getAttribute('href') : null;
    if (!handle) return;

    var wishlist = getList('cc_wishlist');
    var compare = getList('cc_compare');
    var inWishlist = wishlist.indexOf(handle) > -1;
    var inCompare = compare.indexOf(handle) > -1;

    var wrap = document.createElement('div');
    wrap.className = 'quickview-extra-links';
    wrap.style.cssText = 'display:flex;gap:1.6rem;margin-top:1rem;';

    var wishBtn = document.createElement('button');
    wishBtn.type = 'button';
    wishBtn.className = 'link';
    wishBtn.textContent = inWishlist ? 'Remove from wishlist' : 'Add to wishlist';
    wishBtn.addEventListener('click', function () {
      toggleItem('cc_wishlist', handle, wishBtn, 'Add to wishlist', 'Remove from wishlist');
    });

    var compareBtn = document.createElement('button');
    compareBtn.type = 'button';
    compareBtn.className = 'link';
    compareBtn.textContent = inCompare ? 'Remove from compare' : 'Compare';
    compareBtn.addEventListener('click', function () {
      toggleItem('cc_compare', handle, compareBtn, 'Compare', 'Remove from compare');
    });

    wrap.appendChild(wishBtn);
    wrap.appendChild(compareBtn);
    container.appendChild(wrap);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[id^="QuickAddInfo-"]')) {
          enhanceModal(node);
        }
        var inner = node.querySelector ? node.querySelector('[id^="QuickAddInfo-"]') : null;
        if (inner) enhanceModal(inner);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
